import React, { Component } from 'react';
import PropTypes from 'prop-types';

class RegistryCollectionItemTileActions extends Component {

  constructor(props) {
    super(props);

    this.canPurchase = this.canPurchase.bind(this);
    this.canQuickAdd = this.canQuickAdd.bind(this);
    this.buttonAction = this.buttonAction.bind(this);
  }

  canPurchase() {
    const { collectionItem } = this.props;

    return (collectionItem.type === 'ZOLA') ? collectionItem.actions.add_to_cart : collectionItem.actions.purchase;
  }

  canQuickAdd() {
    const { collectionItem } = this.props;

    return collectionItem.actions.add_to_cart && (
      (collectionItem.type === 'EXTERNAL' && collectionItem.cash_fund && !collectionItem.contributions.group_gift) ||
      (collectionItem.type !== 'EXTERNAL' && !collectionItem.contributions.group_gift)
    );
  }

  buttonAction() {
    const { onAddToCart, onShowProduct } = this.props;

    if (this.canQuickAdd()) {
      onAddToCart();
    } else {
      onShowProduct();
    }
  }

  render() {
    const { collectionItem } = this.props;

    return (
      <span>
        {this.canPurchase() ? (
          <a role="button" className="btn btn-primary" onClick={this.buttonAction}>{collectionItem.button_cta}</a>
        ) : (
          <span className="registry-item-status unavailable text-muted text-uppercase">{collectionItem.button_cta}</span>
        )}
      </span>
    );
  }
}

RegistryCollectionItemTileActions.propTypes = {
  collectionItem: PropTypes.shape({}).isRequired,
  onAddToCart: PropTypes.func.isRequired,
  onShowProduct: PropTypes.func.isRequired
};

export default RegistryCollectionItemTileActions;



/** WEBPACK FOOTER **
 ** ./src/components/registry/RegistryCollectionItemTileActions.jsx
 **/